import { DEVICE_TYPE } from 'Constants/constants'

export type NetPriceCalculatorInput = {
  calculationVisible: boolean
  childAllowanceValue: number
  churchTaxValue: number
  collapse: boolean
  healthValue: string
  salaryValue: string
  stateValue: string
  taxClassValue: number
}

export type OrderLimitation = {
  initial: number
  current: number
}

export type OrderLimitations = {
  [DEVICE_TYPE.Laptop]: OrderLimitation
  [DEVICE_TYPE.Tablet]: OrderLimitation
  [DEVICE_TYPE.Smartphone]: OrderLimitation
  [DEVICE_TYPE.Other]: OrderLimitation
}

export enum OrderFilterTypeEnum {
  Colors,
  ProductTypes,
  Manufacturers,
  Storages,
}

export type OrderFilters = Map<OrderFilterTypeEnum, Set<string>>

export enum OrderStepEnum {
  device = 'device',
  accessories = 'accessories',
  address = 'address',
  summary = 'summary',
  result = 'result',
  finished = 'finished',
}

export enum OrderSortCriteriaEnum {
  Default = 'DeviceChooserFilters_recommended',
  CopaymentNet = 'DeviceChooserFilters_price',
  Manufacturer = 'DeviceChooserFilters_manufacturer',
  Storage = 'DeviceChooserFilters_memory',
}

export type OrderTotalPrice = {
  totalWithoutTax: number
  totalWithTax: number
}

export enum OriginRouteTypeEnum {
  Employee = 'employee',
  Rental = 'rental',
  Rentals = 'rentals',
}

export type OriginRoute = {
  type: OriginRouteTypeEnum
  url: string
} | null
